import { isArray } from './isArray';
export function isNumeric(val) {
  return !isArray(val) && val - parseFloat(val) + 1 >= 0;
}
